/**
 * Get last intercepted data (for debugging).
 *
 * @since 1.0.0
 */

import type { InterceptedData } from '../types';

/**
 * Store last intercepted data.
 *
 * @since 1.0.0
 */
let lastInterceptedData: InterceptedData | null = null;

/**
 * Store intercepted data for debugging purposes.
 *
 * @since 1.0.0
 *
 * @param data - Intercepted data to store.
 */
export const storeInterceptedData = (data: InterceptedData): void => {
  lastInterceptedData = data;
};

/**
 * Get last intercepted data (for debugging).
 *
 * @since 1.0.0
 *
 * @return Intercepted data or null if none available.
 */
export const getInterceptedData = (): InterceptedData | null => {
  return lastInterceptedData;
};

/**
 * Clear stored intercepted data.
 *
 * @since 1.0.0
 */
export const clearInterceptedData = (): void => {
  lastInterceptedData = null;
};
